import { FlexRow } from '@/components/common/Flex';
import { FinancialEntityOwnershipType } from '@common/graphql/generated';
import { OwnershipIndividual, OwnershipJoint } from '../common/icons';

export const OwnershipType = ({
    value,
}: {
    value: FinancialEntityOwnershipType;
}) => {
    if (value === 'INDIVIDUAL') {
        return (
            <FlexRow alignItems="center">
                <OwnershipIndividual mr={2} />
                Individual
            </FlexRow>
        );
    }

    // Joint
    return (
        <FlexRow alignItems="center">
            <OwnershipJoint mr={2} />
            Joint
        </FlexRow>
    );
};
